/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="NotFound">
      <h3>Sorry, page not found!</h3>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/containers/NotFound.js